import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { getExpiryStatus, formatExpiryRemaining } from '../../lib/utils/expiry';

var root = $.from_html(`<span> </span>`);

function ExpiryBadge($$anchor, $$props) {
	$.push($$props, true);

	const status = $.derived(() => getExpiryStatus($$props.expiresAt));
	const label = $.derived(() => formatExpiryRemaining($$props.expiresAt));
	var span = root();
	var text = $.child(span, true);

	$.reset(span);

	$.template_effect(() => {
		$.set_class(span, 1, `badge badge-${$.get(status) ?? ''}`, 'svelte-zm0qs4pgxla0');
		$.set_text(text, $.get(label));
	});

	$.append($$anchor, span);
	$.pop();
}

if (import.meta.hot) {
	ExpiryBadge = $.hmr(ExpiryBadge);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-zm0qs4pgxla0');
		ExpiryBadge[$.HMR].update(module.default);
	});
}

export default ExpiryBadge;
import "bun-svelte:ExpiryBadge.svelte-rpagvykedx7o-style.css";